<div class="_flex _flex-col xs:_flex-row _gap-1 xs:_gap-2">
    <i class="fa-light _center-xy" [ngClass]="decidingFactor.icon | faIconMap"></i>
    <div class="_flex _flex-col">
        <div class="_text-md">{{decidingFactor.title}}</div>
        <div class="_text-md _p-2" *ngIf="!titleOnly && decidingFactor.subtitle">
            {{decidingFactor.subtitle}}
        </div>
    </div>
</div>
